.google-play {
  max-width: 128px;
  width: 100%;
}

.apple-store {
  margin-top: 4px;
}
